import Modal from "../../../../elements/Modal";
import ManageChatHistoryModal from "../ManageChatHistoryModal";

const ManageChatHistoryyModal = ({
  open,
  close = () => {},
  getResponse = {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl4" title={"Reply History"}>
      <ManageChatHistoryModal
        close={close}
        getResponse={getResponse}
        data={data}
      />
    </Modal>
  );
};

export default ManageChatHistoryyModal;
